import { retrieveLaunchParams } from '@tma.js/sdk';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { createGlobalStyle } from 'styled-components';

import { EnvUnsupported } from 'components/EnvUnsupported';
import { Root } from 'components/Root';
import { init } from 'init';

import '@telegram-apps/telegram-ui/dist/styles.css';
import 'material-icons/iconfont/material-icons.css';

// Mock the environment in case, we are outside Telegram.
import {
  addHealthLeeQuestCompletionFromStartParam,
  fixOverscroll,
  navigateIfAchievementCategoryParamsPresent,
  navigateIfOAuthParamsPresent,
  navigateIfPremiumParamPresent,
} from './helpers/common';
import { BRAND_PRIMARY } from './helpers/brandColors';
import { initI18n } from './i18n';
import './mockEnv';

initI18n();

const GlobalStyle = createGlobalStyle`
  :root {
    --fl-brand-orange: ${BRAND_PRIMARY};
    --tgui--button_color: var(--fl-brand-orange) !important;
    --tgui--link_color: var(--fl-brand-orange) !important;
    --tg-theme-button-color: var(--fl-brand-orange) !important;
    --tg-theme-accent-text-color: var(--fl-brand-orange) !important;
    --tg-theme-link-color: var(--fl-brand-orange) !important;
  }
  body {
    background: var(--tg-theme-secondary-bg-color, white);
    padding: 0;
    margin: 0;
  }
  html, body, #root {
    width: 100%;
    height: 100%;
    overflow: hidden;
    overscroll-behavior: none;
  }
  #root {
    /* Preserve scrolling behavior */
    overflow-y: auto;
  }
`;

fixOverscroll();
const root = createRoot(document.getElementById('root')!);

try {
  // Configure all application dependencies.
  const { tgWebAppStartParam } = retrieveLaunchParams();
  const startParam = tgWebAppStartParam ?? new URLSearchParams(window.location.search).get('startapp') ?? undefined;
  init(startParam === 'debug' || process.env.REACT_APP_DEV === 'true');
  navigateIfOAuthParamsPresent(startParam);
  navigateIfAchievementCategoryParamsPresent(startParam);
  navigateIfPremiumParamPresent(startParam);
  addHealthLeeQuestCompletionFromStartParam(startParam);

  root.render(
    <StrictMode>
      <GlobalStyle />
      <Root />
    </StrictMode>,
  );
} catch (e) {
  root.render(<EnvUnsupported/>);
}
